<template>
  <v-snackbar v-model="snackbar" :timeout="10000" :color="color" top>
    <div>{{ $t("message") }}</div>
    <v-btn @click="snackbar=false" text>Close</v-btn>
  </v-snackbar>
</template>

<i18n>
{
  "en": {
    "message": "No shop found within the displayed area"
  },
  "ja": {
    "message": "表示範囲内では店舗が見つかりませんでした"
  }
}
</i18n>

<script>
import { EventBus } from "@/event.js";

export default {
  data() {
    return {
      snackbar: false,
      color: null
    };
  },
  created() {
    EventBus.$on("error", message => {
      this.text = message;
      this.snackbar = true;
      this.color = "error";
    });
    EventBus.$on("success", message => {
      this.text = message;
      this.snackbar = true;
      this.color = "success";
    });
  }
};
</script>

